





























import { Component, Mixins, Prop } from 'vue-property-decorator'
import BasePage from '@/tcw/components/BasePage'
import { AppItemRecord, MenuItem } from '@/tcw/domain/types'

@Component
export default class AppMenuList extends Mixins(BasePage) {
  @Prop({ default: 80 })
  private boxHeight!: number
  @Prop({ default: 90 })
  private boxWidth!: number
  @Prop({ default: () => [] })
  private items!: AppItemRecord[]

  private iconSize = 'fa-2x'
  private colCount = 3

  get boxStyle(): { [key: string]: string } {
    return { height: `${this.boxHeight}px`, width: `${this.boxWidth}px` }
  }

  get colspan(): number {
    return 24 / (this.colCount - 0)
  }

  private iconClass(icon: string): string {
    return `${icon} ${this.iconSize}`
  }
  private getBadge(item: MenuItem): string | number | undefined {
    if (typeof item.badge === 'string') {
      return item.badge
    } else if (typeof item.badge === 'function') {
      return item.badge()
    } else {
      return undefined
    }
  }
}
